var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.339 14.085L15.9998 9.42436L20.663 14.0874L23.375 11.3754L15.9998 4L8.62713 11.373L11.339 14.085ZM4 15.9996L6.71208 13.2875L9.42399 15.9995L6.71193 18.7115L4 15.9996ZM11.339 17.915L15.9998 22.5756L20.6629 17.9127L23.3763 20.6232L23.375 20.6247L15.9998 28L8.62689 20.6272L8.62305 20.6234L11.339 17.915ZM22.5761 16.0011L25.2882 13.289L28.0001 16.0009L25.288 18.713L22.5761 16.0011Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7506 15.9986H18.7518L15.9998 13.2466L13.966 15.2804H13.9659L13.7323 15.5141L13.2504 15.9962L13.2465 15.9999L13.2504 16.0038L15.9998 18.7534L18.7518 16.0014L18.7531 15.9999L18.7506 15.9986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.558a1d1e43dcc1d9949551aae0b060b3.svg";
export { ForwardRef as ReactComponent };